import { useSuspenseQuery } from '@tanstack/react-query';

import { PublicationImpactFactor } from '@/module/Journal/components/PublicationImpactFactor';

import { Id } from '@feature/utils';

import { getArticleImpactFactorOptions } from '../model/ArticleQuery';

interface ArticleImpactFactorProps {
  articleId: Id;
  hideTemporary?: boolean;
}

export function ArticleImpactFactor({ articleId, hideTemporary }: ArticleImpactFactorProps) {
  const { data } = useSuspenseQuery(getArticleImpactFactorOptions(articleId));

  return (
    <PublicationImpactFactor
      hideTemporary={hideTemporary}
      data={data}
    />
  );
}
